<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">竞猜</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
      </div>
      <el-tabs :value="status" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane
          v-for="(type, key) in statusTypes"
          :key="key"
          :label="type.text"
          :name="key"
        ></el-tab-pane>
      </el-tabs>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import { STATUS_TYPES } from './constants.js';

export default {
  name: 'quizProjects',
  data() {
    return {
      statusTypes: STATUS_TYPES,
      status: 'all'
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('quiz', ['pagination'])
  },
  methods: {
    ...mapActions('quiz', ['getList', 'getAllCoins']),
    handleTabChange(tab) {
      this.status = tab.name;
      this.getProjectList({ page: 1 });
    },
    getProjectList(data = {}) {
      this.getList({
        status: this.status === 'all' ? undefined : this.status,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getAllCoins();
    this.getProjectList();
  }
};
</script>
